import React from 'react';
import { Box, Card, CardContent, CardActions, Typography, Button, Chip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

function FeedAlgoCard({ feed, onEdit, onDelete, onDuplicate }) {
  if (!feed) {
    return (
      <Card variant="outlined">
        <CardContent>
          <Typography variant="body2" color="text.secondary">
            Select a feed algo to view details
          </Typography>
        </CardContent>
      </Card>
    );
  }

  const formatValue = (v) =>
    typeof v === 'object' && v !== null ? JSON.stringify(v) : String(v ?? '—');

  const feedType = formatValue(feed.feed_type);
  const feedInputs = formatValue(feed.feed_inputs);
  const sdkVersion = formatValue(feed.sdk_version);

  return (
    <Card variant="outlined">
      <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 1, p: 0 }}>
        {/* Title: feed id and name */}
        <Box sx={{ px: 2, pt: 1.5, pb: 0 }}>
          <Typography variant="h6" component="h2">
            Feed algo #{feed.algo_id}: {feed.name}
          </Typography>
        </Box>

        {/* Body: chips, description, algorithm */}
        <Box sx={{ px: 2, flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            <Chip label={feedType} size="small" variant="outlined" />
            <Chip
              label={
                feedInputs === 'none' || !feed.feed_inputs
                  ? 'Not personalized'
                  : `Personalized by ${feedInputs}`
              }
              size="small"
              variant="outlined"
            />
            <Chip label={`DSL: ${sdkVersion}`} size="small" variant="outlined" />
            <Chip label={feed.is_public ? 'Public' : 'Private'} size="small" variant="outlined" />
          </Box>

          {feed.description && (
            <Typography variant="body2" color="text.secondary">
              {feed.description}
            </Typography>
          )}

          <Box
            component="pre"
            sx={{
              p: 1.5,
              m: 0,
              borderRadius: 1,
              border: 1,
              borderColor: 'divider',
              backgroundColor: 'action.hover',
              fontFamily: 'monospace',
              fontSize: '0.8rem',
              overflow: 'auto',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
            }}
          >
            {feed.algorithm ?? '—'}
          </Box>
        </Box>

      </CardContent>
      <CardActions sx={{ justifyContent: 'flex-end', gap: 1, px: 2, py: 1.5 }}>
        <Button
          size="small"
          color="error"
          startIcon={<DeleteIcon />}
          onClick={() => onDelete?.(feed)}
        >
          Delete
        </Button>
        <Button
          size="small"
          variant="text"
          color="primary"
          startIcon={<ContentCopyIcon />}
          onClick={() => {
            const { algo_id, ...rest } = feed;
            onDuplicate?.({ ...rest, name: feed.name ? `Copy of ${feed.name}` : 'Copy of feed algo' });
          }}
        >
          Duplicate
        </Button>
        <Button
          size="small"
          variant="text"
          color="primary"
          startIcon={<EditIcon />}
          onClick={() => onEdit?.(feed)}
        >
          Edit
        </Button>
      </CardActions>
    </Card>
  );
}

export default FeedAlgoCard;
